module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.selectedMissionSlots) ? _c('b-modal', {
    ref: "missionSlotSelectionEditModal",
    attrs: {
      "id": "missionSlotSelectionEditModal",
      "size": "lg",
      "title": _vm.$t('mission.modal.slot.selection.edit'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.clearMissionSlotSelectionEditData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$tc('mission.slot.selection.edit', _vm.selectedMissionSlots.length, {
        count: _vm.selectedMissionSlots.length
      }))
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, _vm._l((_vm.selectedMissionSlots), function(slot) {
    return _c('li', {
      key: slot.uid
    }, [_c('strong', [_vm._v("#" + _vm._s(slot.orderNumber))]), _vm._v(" - " + _vm._s(slot.title))])
  }))]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.editMissionSlotSelection($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.description'),
      "state": "success",
      "description": _vm.$t('mission.slot.description.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": ""
    },
    model: {
      value: (_vm.missionSlotSelectionEditData.description),
      callback: function($$v) {
        _vm.missionSlotSelectionEditData.description = $$v
      },
      expression: "missionSlotSelectionEditData.description"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.difficulty'),
      "state": "success",
      "description": _vm.$t('mission.slot.difficulty.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionSlotEditDifficultyOptions
    },
    model: {
      value: (_vm.missionSlotSelectionEditData.difficulty),
      callback: function($$v) {
        _vm.missionSlotSelectionEditData.difficulty = $$v
      },
      expression: "missionSlotSelectionEditData.difficulty"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.restricted.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.restricted.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotSelectionEditData.restricted),
      callback: function($$v) {
        _vm.missionSlotSelectionEditData.restricted = $$v
      },
      expression: "missionSlotSelectionEditData.restricted"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.reserve.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.reserve.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotSelectionEditData.reserve),
      callback: function($$v) {
        _vm.missionSlotSelectionEditData.reserve = $$v
      },
      expression: "missionSlotSelectionEditData.reserve"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.blocked.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.blocked.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotSelectionEditData.blocked),
      callback: function($$v) {
        _vm.missionSlotSelectionEditData.blocked = $$v
      },
      expression: "missionSlotSelectionEditData.blocked"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.autoAssignable.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.autoAssignable.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotSelectionEditData.autoAssignable),
      callback: function($$v) {
        _vm.missionSlotSelectionEditData.autoAssignable = $$v
      },
      expression: "missionSlotSelectionEditData.autoAssignable"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.missionSlotSelectionEditData.restricted) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.restricted.selection'),
      "state": _vm.missionSlotEditRestrictedCommunityState,
      "description": _vm.$t('mission.slot.restricted.selection.description')
    }
  }, [_c('typeahead', {
    attrs: {
      "action": "searchCommunities",
      "actionIndicator": "searchingCommunities",
      "onHit": _vm.restrictedSlotCommunitySelected
    }
  })], 1)], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot selection edit actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.editMissionSlotSelection
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotSelectionEditModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81d11e64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionSlotSelectionEditModal.vue
// module id = 549
// module chunks = 0